import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  path?: string;
}

const SITE_NAME = '동두천시 글로벌인재교육센터';
const DEFAULT_DESCRIPTION = '동두천시 글로벌인재교육센터 - 영어 교육, 수강 신청 및 프로그램 안내. 유아부터 성인까지 다양한 영어 교육 프로그램을 제공합니다.';
const DEFAULT_KEYWORDS = '동두천, 글로벌인재교육센터, 영어교육, 수강신청, 동두천영어, 글로벌교육, 동두천글로벌인재교육센터, 동두천시글로벌인재교육센터, 동두천시영어교육';
const SITE_URL = 'https://www.ddcglobalcenter.com';
const DEFAULT_OG_IMAGE = 'https://www.ddcglobalcenter.com/logo512.png';

const SEO: React.FC<SEOProps> = ({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  path = '',
}) => {
  const fullTitle = title ? `${title} - ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
